<template>
  <div class="monitor">
    <div class="monitor-left">
      <div v-for="(order, key) in orders" :key="key" class="monitor-left-item order-info">
        <p class="order-title">{{order.name}}: <span>{{order.pay + order.notPay}}</span></p>
        <div class="order-container">
          <div class="order-item">
            <p>{{order.pay}}</p>
            <p class="order-item-name">{{$t('zhi_fu_ding_dan')}}</p>
          </div>
          <div class="order-item">
            <p>{{order.notPay}}</p>
            <p class="order-item-name">{{$t('fei_zhi_fu_ding_dan')}}</p>
          </div>
          <div class="order-item">
            <p>{{(order.money / 100).toFixed(2)}}</p>
            <p class="order-item-name">{{$t('xiao_shou_e')}}</p>
          </div>
        </div>
      </div>
      <top10-drink-pie class="monitor-left-item"></top10-drink-pie>
      <top10-device-pie class="monitor-left-item"></top10-device-pie>
    </div>
    <div class="monitor-middle">
      <div class="middle-head">
        <div class="logo">
          <img :src="logo"/>
        </div>

        <div class="tab">
          <span>{{$t('yun_ying_shu_ju')}}</span>
        </div>
        <label @click="fullScreen"> <i class="iconfont iconquanping"></i>{{$t('wang_ye_quan_ping')}}</label>
        <label @click="enterApp" v-if="navMenus.length > 0"> <i class="iconfont iconshouye"></i>{{$t('jin_ru_ping_tai')}}</label>
      </div>

      <div class="middle-container" id="middleContainer">
        <div class="middle-money">
          <div class="middle-item">
            <p>{{$t('lei_ji_ding_dan_jin_e')}} ({{$t('yuan')}}) </p>
            <div class="middle-digit digit-money" id="sumOrderMoney">
              <i-count-up
                :start="0"
                :endVal="orderInfo.money"
                :duration="1"
                :options="moneyOptions"
              ></i-count-up>
            </div>
          </div>
          <div class="middle-item">
            <p>{{$t('lei_ji_ding_dan_shu')}}</p>
            <div class="middle-digit" id="sumOrderNumber">
              <i-count-up
                :start="0"
                :endVal="orderInfo.orders"
                :decimals="2"
                :duration="1"
                :options="options"
              ></i-count-up>
            </div>

          </div>
        </div>
        <div class="middle-chart" id="seller-chart"></div>
      </div>

      <baidu-map class="chart"
                 id="mapContainer"
                 @ready="mapInit"
                 :scroll-wheel-zoom="true"
                 :zoom="5"
                 ak="m8uvtsyme94l8w9SyjzIyt0oAd00DFSt"
                 :center="{lng: 103.737765, lat: 37.910329}"
      >

      </baidu-map>
    </div>
    <div class="monitor-right">
      <top10-drink-bar class=" item order-drink"></top10-drink-bar>
      <top10-device-bar class="item order-device"></top10-device-bar>
      <div class="item order-lst24hour">
        <div class="title">{{$t('zheng_dian_shi_shi_ding_dan')}}</div>
        <div class="chart" id="orderLst24hour">

        </div>
      </div>
    </div>

    <div class="ball" ref="items" v-for="(item, index) in items" :key="index"
         v-if="item !== undefined && item.show"
         :class="item.clazz" :style="{backgroundImage:`url('`+item.src+`')`}">
    </div>

  </div>
</template>

<script>
  import 'echarts/map/js/china';
  import BaiduMap from '@/components/BaiduMap/map/Map.vue'
  import ICountUp from 'vue-countup-v2';

  import Top10DrinkPie from '@/components/Top10DrinkPie'
  import Top10DevicePie from '@/components/Top10DevicePie'
  import Top10DeviceBar from '@/components/Top10DeviceBar'
  import Top10DrinkBar from '@/components/Top10DrinkBar'
  import {distributeIm} from '@/api/delivery/organization/distribute'
  import {drinkDeviceAll} from '@/api/delivery/device/drink'
  import {deviceAll} from '@/api/delivery/device/list'
  import {orderSurvey, orderlst24H} from '@/api/delivery/order/order'
  import client from '@/assets/js/mqttclient'
  import echarts from 'echarts'
  import {mapGetters, mapActions} from 'vuex'
  import {enterpriseLogo} from '@/api/account/enterprise'

  export default {
    components: {
      BaiduMap,
      Top10DeviceBar,
      Top10DrinkBar,
      Top10DrinkPie,
      Top10DevicePie,
      ICountUp
    },
    data() {
      let vue = this
      let hours = vue.$t('dian')
      return {
        orders: [
          {name: vue.$t('jin_ri_ding_dan_shu'), pay: 0, notPay: 0, money: 0},
          {name: vue.$t('ben_zhou_ding_dan_shu'), pay: 0, notPay: 0, money: 0},
          {name: vue.$t('ben_yue_ding_dan_shu'), pay: 0, notPay: 0, money: 0},
        ],
        logo :'http://img.dr-coffee.cn/logo.0e11affe.png',
        mapStyle: {styleId: 'c03f32154b45b0bddcffba799a8cb827'},
        boundCart: {left: 0, top: 0, width: 100, height: 100,},
        mapContainer: {left: 0, top: 0, width: 100, height: 100,},
        sumOrderNumber: {left: 0, top: 0, width: 100, height: 100,},
        items: [],
        pushItems: [],
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: ''
        },
        decimals: 2,
        moneyOptions: {
          useEasing: true,
          useGrouping: true,
          decimalPlaces: 2,
          separator: '',
          decimal: '.',
          prefix: '¥',
          suffix: ''
        },
        orderInfo: {
          orders: 0,
          money: 0.00,
        },
        drinks: {},
        devices: {},
        sellerOption: {
          title: {
            text: vue.$t('yu_shang_yue_dui_bi_bei_liang_qing_kuang'),
            textStyle: {
              color: '#F2f2f2',
            },
            x: 'center',
            textAlign: 'center'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              lineStyle: {
                color: '#57617B'
              }
            }
          },
          legend: {
            selectedMode: false,
            type: 'plain',
            x: 'right',
            data: [vue.$t('ben_yue'), vue.$t('shang_yue')],
            icon: 'pin',
            textStyle: {
              color: '#F2f2f2'
            }
          },
          grid: {
            left: '8%',
            right: 30,
            bottom: '14%',
            top: '16%'
          },
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            axisTick: {
              alignWithLabel: true
            },
            axisLine: {
              lineStyle: {
                color: '#E2E2E2'
              }
            },
            axisLabel: {
              color: '#E2E2E2'
            },
            data: []
          }],
          yAxis: [{
            type: 'value',
            name: this.$t('unit_cup'),
            axisLine: {
//                            show: false,
              lineStyle: {
                color: '#E2E2E2'
              }
            },
            axisLabel: {
              color: '#E2E2E2'
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#e2e2e2',
                type: 'dashed'
              }
            },
            axisTick: {
              show: false
            }
          }],
          series: [{
            name: vue.$t('ben_yue'),
            type: 'line',
            smooth: true,
            lineStyle: {
              normal: {
                width: 1
              }
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: 'rgba(7,44,90,0.3)'
                }, {
                  offset: 1,
                  color: 'rgba(0,212,199,0.9)'
                }]),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10
              }
            },
            itemStyle: {
              normal: {
                color: 'rgb(0,212,199)'

              }
            },
            data: []
          }, {
            name: vue.$t('shang_yue'),
            type: 'line',
            smooth: true,
            lineStyle: {
              normal: {
                width: 1
              }
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: 'rgba(7,44,90,0.3)'
                }, {
                  offset: 1,
                  color: 'rgba(0,146,246,0.9)'
                }]),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10

              }
            },
            itemStyle: {
              normal: {
                color: 'rgb(0,146,246)'
              }
            },
            data: []
          }]
        },
        chart: null,
        lst24HOption: {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              lineStyle: {
                color: '#57617B'
              }
            },
            formatter: function (params) {
              let param = params[0]
              return param.name + hours + '<br/>' + param.seriesName + ':' + param.data
            },
          },
          legend: {
            selectedMode: false,
            type: 'plain',
            x: 'right',
            data: [vue.$t('dang_tian')],
            icon: 'pin',
            textStyle: {
              color: '#F2f2f2'
            }
          },
          grid: {
            left: '8%',
            right: 30,
            bottom: '14%',
            top: '16%'
          },
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            axisTick: {
              alignWithLabel: true
            },
            axisLine: {
              lineStyle: {
                color: '#E2E2E2'
              }
            },
            axisLabel: {
              color: '#E2E2E2'
            },
            data: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13',
              '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
          }],
          yAxis: [{
            type: 'value',
            name: vue.$t('unit_cup'),
            axisLine: {
//                            show: false,
              lineStyle: {
                color: '#E2E2E2'
              }
            },
            axisLabel: {
              color: '#E2E2E2'
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#e2e2e2',
                type: 'dashed'
              }
            },
            axisTick: {
              show: false
            }
          }],
          series: [{
            name: vue.$t('zhi_zuo_bei_shu'),
            type: 'line',
            smooth: true,
            lineStyle: {
              normal: {
                width: 1
              }
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: 'rgba(7,44,90,0.3)'
                }, {
                  offset: 1,
                  color: 'rgba(0,212,199,0.9)'
                }]),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10
              }
            },
            itemStyle: {
              normal: {
                color: 'rgb(0,212,199)'

              }
            },
            data: []
          }]
        },
        lst24Hchart: null,
        periodTs: null,
        consumeTs: 0
      }
    },
    computed: {
      ...mapGetters(['navMenus', 'notifyConnect'])
    },
    methods: {
      pic(itemData, index) {
        let vue = this
        let {price, lng, lat} = itemData
        const pixel = vue.map.pointToPixel({lng: lng, lat: lat})
        let item = this.$refs.items[index]
        if (!item) {
          if (!this.items[index]) {
            this.items.splice(index, 1)
          }
          return
        }

        item.style.left = (vue.mapContainer.left + pixel.x) + 'px';
        item.style.top = (vue.mapContainer.top + pixel.y) + 'px';
        item.style.width = '32px'
        item.style.height = '32px'


        item.style.display = 'block'
        item.style.backgroundColor = '#0EBF9C'
        itemData.clazz = 'anim'

        setTimeout(function () {
          itemData.clazz = ''
          vue.$set(vue.items, index, itemData)
          item.style.transition = 'left 1s linear, top 1s cubic-bezier(.48, 0, .94, .28)'
          if (price) {
            item.style.left = (vue.boundCart.left + vue.boundCart.width / 2) + 'px';
            item.style.top = (vue.boundCart.top + vue.boundCart.height / 2) + 'px';
          } else {
            item.style.left = (vue.sumOrderNumber.left + vue.sumOrderNumber.width / 2) + 'px';
            item.style.top = (vue.sumOrderNumber.top + vue.sumOrderNumber.height / 2) + 'px';
          }
          item.style.backgroundColor = '#f6cf01'
          item.style.width = '16px'
          item.style.height = '16px'
          setTimeout(function () {
            if (price) {
              vue.orderInfo.money += price / 100
              vue.orders[0].pay += 1
              vue.orders[0].money += price
              vue.orders[1].pay += 1
              vue.orders[1].money += price
              vue.orders[2].pay += 1
              vue.orders[2].money += price
            } else {
              vue.orders[0].notPay += 1
              vue.orders[1].notPay += 1
              vue.orders[2].notPay += 1
            }

            vue.orderInfo.orders += 1
            item.style.zIndex = 0
            item.style.display = 'none'
            itemData.show = false
            vue.$set(vue.items, index, itemData)
          }, 1100)

        }, 2100)
      },

      mapInit({BMap, map}) {
        this.map = map
        map.setMapStyleV2({styleId: 'c03f32154b45b0bddcffba799a8cb827'})

      },
      enterApp() {
        if (this.navMenus.length > 1) {
          this.$router.push({name: this.navMenus[1].modules[0].webRouterName})
        }

      },
      isFullScreen() {
        return document.fullscreenElement ||
          document.msFullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement || false;
      },
      exitFullscreen() {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      },
      fullScreen() {
        let element = document.documentElement;

        if (!this.isFullScreen()) {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        } else {
          this.exitFullscreen()
        }
      },
      syncCenterAndZoom(e) {

      },
      chartSelect(chart, data) {
//                let data = this.bar.series[0].data
        var hourIndex = 0;
        var fhourTime = null;
        fhourTime = setInterval(function () {
          chart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,

          });
          chart.dispatchAction({
            type: "highlight",
            seriesIndex: 0,
            dataIndex: hourIndex
          });
          chart.dispatchAction({
            type: "showTip",
            seriesIndex: 0,
            dataIndex: hourIndex
          });
          hourIndex++;
          if (hourIndex > data.length) {
            hourIndex = 0;
          }
        }, 2000);

        chart.on("mousemove", function (e) {
          clearInterval(fhourTime)
          chart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
          });
          chart.dispatchAction({
            type: "highlight",
            seriesIndex: 0,
            dataIndex: e.dataIndex
          });
          chart.dispatchAction({
            type: "showTip",
            seriesIndex: 0,
            dataIndex: e.dataIndex
          });
        })
        //鼠标移出恢复轮播
        chart.on("mouseout", function () {
          fhourTime = setInterval(function () {
            chart.dispatchAction({
              type: "downplay",
              seriesIndex: 0,

            });
            chart.dispatchAction({
              type: "highlight",
              seriesIndex: 0,
              dataIndex: hourIndex
            });
            chart.dispatchAction({
              type: "showTip",
              seriesIndex: 0,
              dataIndex: hourIndex
            });
            hourIndex++;
            if (hourIndex > data.length) {
              hourIndex = 0;
            }
          }, 3000);
        })
      },
      messageArrive(message) {
        try {
          let order = JSON.parse(message.payloadString)
          let device = this.devices[order.deviceUuid]
          let drink = this.drinks[order.drinkUuid]
          try {
            if (!device.lat) {
              device.lat = 31.981216
              device.lng = 118.816832
            } else {
              device.lat = parseFloat(device.lat)
              device.lng = parseFloat(device.lng)
            }
          } catch (e) {
            device = {}
            device.lat = 31.981216
            device.lng = 118.816832
          }

          let img;
          try {
            img = drink.img
            if (!img) {
              img = `http://img.dr-coffee.cn/drink/default/caffe_latte.png`
            }
          } catch (e) {
            img = `http://img.dr-coffee.cn/drink/default/caffe_latte.png`
          }
          let item = {
            clazz: 'anim',
            src: img,
            money: order.money || 0,
            price: order.money || 0,
            lng: device.lng,
            lat: device.lat,
            show: true,
          }
          this.pushItems.push(item)
        } catch (e) {
          console.log(e)
        }
      },

      ...mapActions(['setConnect']),
      initData() {
        let vue = this
        let strDate = 31;
        orderSurvey().then(res => {
          vue.orderInfo.money = (res.data.totalMoney / 100)
          vue.orderInfo.orders = res.data.totalOrder
          let fn = function t(order, today, other) {
            order.pay = today.payOrder + other.payOrder
            order.notPay = (today.orders - today.payOrder) + (other.orders - other.payOrder)
            order.money = today.sale + other.sale
            return order
          }
          vue.orders[0] = fn(vue.orders[0], res.data.today, {payOrder: 0, orders: 0, sale: 0})
          vue.orders[1] = fn(vue.orders[1], res.data.week, res.data.today)
          vue.orders[2] = fn(vue.orders[2], res.data.month, res.data.today)
          let x = []
          let _lastMonth = []
          let _curMonth = []
          let lastMonth = res.data.lastMonth || []
          let curMonth = res.data.curMonth || []
          for (let i = 1; i <= strDate; i++) {
            x.push(i + '')
            let last = 0
            let cur = 0
            _lastMonth.push(last)
            _curMonth.push(cur)
          }

          for (let i = 0; i < curMonth.length; i++) {
            let info = curMonth[i]
            _curMonth[info.day - 1] = info.orders
          }

          for (let i = 0; i < lastMonth.length; i++) {
            let info = lastMonth[i]
            _lastMonth[info.day - 1] = info.orders
          }

          vue.sellerOption.xAxis[0].data = x
          vue.sellerOption.series[1].data = _lastMonth
          vue.sellerOption.series[0].data = _curMonth
          vue.chart.setOption(vue.sellerOption)
        })
        drinkDeviceAll().then(res => {
          (res.data || []).forEach(item => {
            vue.drinks[item.drinkUuid] = item
          })
        })
        for (let i = 0; i < 24; i++) {
          this.lst24HOption.series[0].data.push(0)
        }
        orderlst24H().then(res => {
          let data = res.data || []
          data.forEach((item) => {
            vue.lst24HOption.series[0].data[item.hour] = item.orders
          })
          vue.lst24Hchart.setOption(vue.lst24HOption)
        })
        deviceAll().then(res => {
          (res.data || []).forEach(item => {
            vue.devices[item.uuid] = item
          })
        })


      }
    },

    mounted() {
      enterpriseLogo().then(res => {
        if (res.data !== ``) {
          this.logo = res.data
        }
      })
      var moneyInfo = document.querySelector('#sumOrderMoney');
      var sumOrderNumber = document.querySelector('#sumOrderNumber');
      var mapContainer = document.querySelector('#mapContainer');
      this.mapContainer = mapContainer.getBoundingClientRect();
      this.boundCart = moneyInfo.getBoundingClientRect();
      this.sumOrderNumber = sumOrderNumber.getBoundingClientRect();
      this.chart = echarts.init(document.getElementById('seller-chart'))
      this.chart.setOption(this.sellerOption)
      this.lst24Hchart = echarts.init(document.getElementById('orderLst24hour'))
      this.lst24Hchart.setOption(this.lst24HOption)
      this.chartSelect(this.lst24Hchart, this.lst24HOption.series[0].data)
      let vue = this
      client.getNode = distributeIm
      client.messageArrived = this.messageArrive
      client.messageLost = () => {
        vue.setConnect(false)
      }
      client.messageConnect = () => {
        vue.setConnect(true)
      }
      if (!this.notifyConnect) {
        client.messageConnectionLost()
      }

      this.initData()
      if (!this.periodTs) {
        let vue = this
        this.periodTs = setInterval(function () {
          vue.initData()
        }, 3600000)
      }

      if (this.consumeTs <= 0) {
        let vue = this
        let idx = 0
        let sendItems = []
        this.consumeTs = setInterval(function () {
          idx = vue.pushItems.length
          if (idx > 0) {
            let showItems = vue.pushItems.splice(0, idx)
            sendItems = sendItems.concat(showItems)
          }

          if (sendItems.length > 0) {
            if (vue.items.length  === 0) {
              vue.items = sendItems.splice(0, sendItems.length)
              vue.$nextTick(function () {
                for (let i = 0; i <vue.items.length; i++) {
                  vue.pic(vue.items[i], i)
                }
              })
            } else {
              let clear = true
              for (let i = 0; i <vue.items.length; i++) {
                if (vue.items[i].show) {
                  clear = false
                }
              }

              if (clear && sendItems.length > 0) {
                vue.items = sendItems.splice(0, sendItems.length)
                vue.$nextTick(function () {
                  for (let i = 0; i <vue.items.length; i++) {
                    vue.pic(vue.items[i], i)
                  }
                })
              }
            }
          }
        }, 500)
      }

      window.onclose = function () {
        client.disconnect()
      }
    },
    beforeDestroy() {
      if (this.consumeTs > 0) {
        clearInterval(this.consumeTs)
      }
      client.disconnect()
    },
    watch: {
      series() {

      }
    }
  }
</script>

<style lang="scss">
  .monitor {
    height: 1080px;
    width: 1920px;
    $height: 72px;
    //$bg-color: rgba(54, 68, 74, .75);
    background-color: #113549ff;
    $bg-color: #30363e;

    .monitor-left, .monitor-right {
      height: calc(100% - 8px);
      z-index: 999;
      top: 8px;
      position: absolute;
    }

    .monitor-left {
      left: 0;
      width: calc(25% - 8px);
      margin-left: 8px;
    }

    .monitor-right {
      right: 0;
      width: calc(25% - 8px);
      margin-right: 8px;
    }

    .monitor-left {
      .order-info {
        .order-title {
          height: $height;
          line-height: $height;
          font-size: 24px;
          color: $f_th_color;
          border-bottom: 1px solid $border_color;
          padding-left: 16px;

          span {
            color: $f_color;
          }
        }
      }

      .order-container {
        display: flex;

        .order-item {
          flex: 1;
          padding: 16px;
          text-align: center;

          p {
            font-size: 20px;
            font-weight: 400;
            color: $f_th_color;
          }

          p:first-child {
            margin-bottom: 16px;
            font-weight: 500;
            font-size: 22px;
            color: $f_color;
          }
        }
      }

      .monitor-left-item:nth-child(-n+3) {
        height: calc(18% - 8px);
        background-color: $bg-color;
        width: 100%;
        margin-bottom: 8px;
      }

      .monitor-left-item {
        height: calc(23% - 8px);
        background-color: $bg-color;
        width: 100%;
        margin-bottom: 8px;
      }
    }

    .monitor-middle {
      width: calc(50% - 16px);
      height: calc(100% - 16px);
      z-index: 999;
      top: 8px;
      position: absolute;
      display: flex;
      flex-direction: column;

      left: 25%;
      margin: 0 8px;

      .middle-head {
        height: $height;
        width: 100%;
        display: flex;
        background-color: $bg-color;
        padding: 0 16px;
        align-content: center;

        .tab {
          flex: 1;
          height: $height;
          text-align: center;
          line-height: $height;
          vertical-align: middle;

          span {
            height: $height - 12px;
            display: inline-block;
            font-size: 24px;
            font-weight: 500;
            color: white;
            border-bottom: 3px solid $f_color;
          }
        }

        label {
          line-height: $height;
          width: 160px;
          text-align: center;
          cursor: pointer;

          i {
            font-size: 22px;
          }
        }

        .logo {
          display: inline-block;
          vertical-align: middle;
          line-height: $height;

          img {
            margin: 16px 0;
            width: auto;
            height: auto;
          }
        }
      }

      .middle-container {

        background-color: $bg-color;
        margin-top: 8px;
        padding: 16px;

        .middle-money {
          height: 108px;
          padding-bottom: 8px;
          border-bottom: 1px solid $border_th_color;
          display: flex;

          .middle-item {
            p {
              font-size: 20px;
              color: $f-th_color;
              font-weight: 500;
            }

            .middle-digit {
              margin: 0 auto;
              max-width: 320px;

              span {
                color: #f6cf01;
                font-size: 56px;
                vertical-align: middle;
                line-height: 80px;
              }
            }

            .d-roll-wrapper {
              margin: 0 auto;

              * {
                color: #f6cf01;
                font-size: 56px;
                font-weight: 600;
              }
            }
          }

          .middle-item:last-child {
            width: 40%;
          }

          .middle-item:first-child {
            border-right: 1px solid $border_th_color;
            width: calc(60% - 16px);
            margin-right: 16px;
          }
        }

        .middle-chart {
          height: 240px;
          padding-top: 16px;
        }
      }

      .chart {
        width: 100%;
        flex: 1;
        z-index: 1
      }
    }

    .monitor-right {

      display: flex;
      flex-direction: column;

      .item {
        background-color: $bg-color;
        margin-bottom: 8px;
        flex: 1;
        width: 100%;
      }

    }

    .money {
      position: absolute;
      z-index: 99;
      top: 0;
      left: 600px;
      text-align: center;

      .money-content {
        width: 180px;
        background-color: $bg-color;
        height: 64px;
      }
    }

    .ball {
      width: 32px;
      height: 32px;
      display: none;
      border-radius: 50%;
      position: absolute;
      z-index: 9999;
      background-size: cover
    }

    .tr {
      transition: left 1s linear, top 1s cubic-bezier(.48, 0, .94, .28);
    }

    .anim {
      -webkit-animation-name: scaleDraw; /*关键帧名称*/
      -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
      -webkit-animation-iteration-count: infinite; /*动画播放的次数*/
      -webkit-animation-duration: 2s; /*动画所花费的时间*/
    }

    @keyframes scaleDraw { /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
      0% {
        transform: scale(0); /*开始为原始大小*/
      }
      25% {
        transform: scale(1);
      }
      50% {
        transform: scale(2);
      }
      75% {
        transform: scale(1);
      }
      100% {
        transform: scale(.2);
      }
    }

    .order-lst24hour {
      /*width: 100%;*/
      /*height: 100%;*/
      display: flex;
      flex-direction: column;

      .title {
        font-weight: 500;
        height: 72px;
        line-height: 72px;
        padding-left: 16px;
        border-bottom: 1px solid $border_color;
        color: $f_th_color;
      }

      .chart {
        flex: 1;
        width: 100%;
      }
    }

  }

  .BMap_cpyCtrl {
    display: none;
  }

  .anchorBL {
    display: none;
  }
</style>
